module.exports = __webpack_public_path__ + "static/media/bg.487a432e.png";